export const checkParams = (value, vtype) => {
  var isValid = false;

  if (vtype === "firstname" && /^[A-Za-z]+$/.test(value) && value.length >= 2) {
    isValid = true;
  }
  if (vtype === "lastname" && /^[A-Za-z]+$/.test(value) && value.length >= 2) {
    isValid = true;
  }  
  if (vtype === "email" && /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(value)) {
    isValid = true;
  }
  if (vtype === "password" && /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/.test(value)) {
    isValid = true;
  }

  if (vtype === "address" && /^[a-zA-Z0-9\s,.'-/]{3,}$/.test(value)) {
    isValid = true;
  }

  if (vtype === "city" && /^[a-zA-Z]+(?:[\s-][a-zA-Z]+)*$/.test(value)) {
    isValid = true;
  }

  if (vtype === "zipcode" && /^\d{5}(-\d{4})?$/.test(value)) {
    isValid = true;
  }

  if (vtype === "ca_zip" && /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVXY][ -]?\d[ABCEGHJKLMNPRSTVXY]\d$/i.test(value)) {
    isValid = true;
  }

  if (!value || value === undefined) {
    isValid = false;
  }

  if (vtype === "birthday" && /^(?:(0[1-9]|1[012])(0[1-9]|[12][0-9]|3[01])(19|20)[0-9]{2})$/.test(value)) {
    isValid = false;
  }
  if (vtype === "charLength" && /^.{8,}$/.test(value)) {
    // register specific
    isValid = true;
  }
  if (vtype === "hasLetter" && /^.*[a-zA-Z]/.test(value)) {
    isValid = true;
  }
  if (vtype === "hasNum" && /^.*\d/.test(value)) {
    isValid = true;
  }
  if (vtype === "hasSpecChar" && /^.*\W/.test(value)) {
    isValid = true;
  }

  // United States phone number
  if (vtype === "phone" && /^(1-)?\d{3}-\d{3}-\d{4}$/.test(value)) {
    isValid = true;
  }

  return isValid;
};

/* export const handleAjaxError = (error) => {
  console.log("err", error);
   if (
    error &&
    error.response &&
    error.response.data &&
    error.response.data.errorData
  ) {
    if (
      error.response.data.errorData.model &&
      error.response.data.errorData.error
    ) {
     setState({
        [error.response.data.errorData.model]:
          error.response.data.errorData.error,
      });
    } else if (error.response.data.errorData.error) {
      console.log("show popup----", error.response.data.errorData.error);
    } 
};*/
